export const uploadFields = [
  {
    id: "b5c09e26-4f8f-4895-85b3-f9246f3d8aa6",
    type: "upload-analysis",
    label: "Загрузить файл",
    content: {
      required: false,
    },
    variable: "analysisFiles",
    helperText: "",
    sequenceNumber: 1,
  },
];